import SocMonthlySummaryDialog from './SocMonthlySummaryDialog';

export { SocMonthlySummaryDialog };
export default SocMonthlySummaryDialog;
